import { useSyncExternalStore } from 'react';

import { tokenStore } from './token-store';
import { getViewerIdentity } from './viewer-identity';

export const getGameResourceOwner = () => {
  const session = tokenStore.get();
  if (session?.sessionType === 'guest') return `guest:${session.guestId ?? session.accessToken}`;
  return getViewerIdentity()?.login;
};

const subscribe = (notify: () => void) => {
  window.addEventListener('uznali-session-changed', notify);
  window.addEventListener('storage', notify);
  return () => {
    window.removeEventListener('uznali-session-changed', notify);
    window.removeEventListener('storage', notify);
  };
};

export const useGameSession = () => {
  useSyncExternalStore(
    subscribe,
    () => JSON.stringify(tokenStore.get()),
    () => 'null',
  );
  return tokenStore.get();
};
